import React, { useState } from 'react'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import { useTheme } from '@mui/material/styles'
import { DialogActions, DialogContent, Grid, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

import DirectionSnackbar from './Snackbar'
import urls from 'utils/urls'
import { makeGetRequest } from 'utils/api'
import { useForm } from 'react-hook-form'
import ComboBox from './ComboBox'
import { Input } from 'Components/Input'
import { convertToMuiDate } from 'utils/helpers'
import { makePostRequest } from 'utils/api'

export default function ResponsiveEditDialog({ updateTable, setSelectedRows, selectedRows }) {
  const theme = useTheme()
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [open, setOpen] = React.useState(false)
  const [account, setAccount] = React.useState({})
  const [openSnack, setOpenSnak] = useState({
    message: '',
    color: '',
    open: false,
  })
  const [state, setState] = useState({
    bankData: null,
    // Titulaire: null,
    IBAN: null,
    newAccType: null,
  })
  const [tmpBank, setTempBank] = useState([])
  const [selectedtempBank, setSelectedTempBank] = useState({})
  const [tmpAccType, setTmpAccType] = useState([])
  const [contacts, setContacts] = useState([])
  const [selectedtmpAccType, setSelectedTmpAccType] = useState({})
  const [selectedcontacts, setselectedContacts] = useState({})

  const { handleSubmit, control, setValue, reset } = useForm({
    defaultValues: {
      id: account.id,
      bankData: '',
      // Titulaire: '',
      IBAN: '',
      DateOuverture: '',
      CléRiB: '',
      NumeroClient: '',
      Devise: '',
    },
  })

  const fetchAccount = async (id) => {
    let url = urls.accountOperations + id

    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setAccount(response.data)
      let a = response.data
      setSelectedTempBank({ label: a.Nom.Nom + ' - ' + a.Nom.Ville, id: a.Nom.id })
      setValue('bankData', selectedtempBank)
      setSelectedTmpAccType({ label: a.TypeCompte.TypeCompte, id: a.TypeCompte.id })
      setValue('newAccType', selectedtmpAccType)
      // setselectedContacts({ label: a.titulaire.Nom, id: a.titulaire.id })
      // setValue('Titulaire', selectedcontacts)
      setValue('id', id)
      setValue('IBAN', a.IBAN)
      setValue('CléRiB', a.CléRiB)
      setValue('NumeroClient', a.NumeroClient)
      setValue('Devise', a.Devise)
      setValue('DateOuverture', convertToMuiDate(a.DateOuverture))
    }
  }
  const handleClickOpen = () => {
    if (selectedRows.length === 1) {
      fetchBankData()
      fetchAccType()
      // fetchContacts()
      fetchAccount(selectedRows[0])
      setOpen(true)
    } else {
      alert(t('finance.mesComptes.selectOneToEdit', { defaultValue: 'Please select one account to edit.' }))
    }
  }

  const handleClose = () => {
    setOpen(false)
    setOpenSnak({ ...openSnack, open: false })
    setState({
      bankData: null,
      // Titulaire: null,
      IBAN: 'null',
      newAccType: null,
    })
  }

  const addAccount = async (data) => {
    const formData = new FormData()
    formData.append('Nom', selectedtempBank.id)
    formData.append('TypeCompte', selectedtmpAccType.id)
    formData.append('IBAN', data.IBAN)
    formData.append('Devise', data.Devise)
    formData.append('id', data.id)
    formData.append('NumeroClient', data.NumeroClient)
    formData.append('CléRiB', data.CléRiB)
    formData.append('DateOuverture', data.DateOuverture)

    // formData.append('Titulaire', selectedcontacts.id || data.Titulaire.id)

    try {
      const res = await makePostRequest('/api/Finance/POST/UpdateAccounts/', formData, {}, true)
      
      // Handle success response (200 OK)
      if (res.status === 200) {
        updateTable()
        handleClose()

        setOpenSnak({
          open: true,
          color: 'success',
          message: res.data?.message || 'Account updated successfully',
        })
        setTimeout(() => {
          setOpenSnak({
            open: false,
            color: 'success',
            message: '',
          })
        }, 2000)
      } else {
        // Handle error responses from server
        const errorMessage = res.data?.error || res.data || 'Failed to update account'
        setOpenSnak({
          open: true,
          color: 'error',
          message: errorMessage,
        })
        setTimeout(() => {
          setOpenSnak({
            open: false,
            color: 'error',
            message: '',
          })
        }, 3000)
      }
    } catch (error) {
      console.error('Update account error:', error)
      
      // Extract error message from response
      let errorMessage = 'Error updating account'
      
      if (error.response?.data) {
        // New format: JSON with error field
        if (typeof error.response.data === 'object' && error.response.data.error) {
          errorMessage = error.response.data.error
        } 
        // Old format: plain text
        else if (typeof error.response.data === 'string') {
          errorMessage = error.response.data
        }
      } else if (error.message) {
        errorMessage = error.message
      }
      
      setOpenSnak({
        open: true,
        color: 'error',
        message: errorMessage,
      })
      setTimeout(() => {
        setOpenSnak({
          open: false,
          color: 'error',
          message: '',
        })
      }, 3000)
    }
  }

  const fetchBankData = async () => {
    const { data } = await makeGetRequest('/api/Finance/Banks/', {}, true)
    const filterBankData = []
    data.map((v) => {
      filterBankData.push({ label: v.Nom + ' - ' + v.Ville, id: v.id })
      return ''
    })
    setTempBank([...filterBankData])
  }
  const fetchAccType = async () => {
    const filterAccType = []
    const { data } = await makeGetRequest('/api/Finance/AccounType/', {}, true)
    data.map((v) => {
      filterAccType.push({ label: v.TypeCompte, id: v.id })
      return ''
    })
    setTmpAccType([...filterAccType])
  }
  // const fetchContacts = async () => {
  //   const filterContacts = []
  //   const { data } = await makeGetRequest('/api/Social/get-all-contacts/', {}, true)
  //   data.map((v) => {
  //     filterContacts.push({ label: v.Nom, id: v.id })
  //     return ''
  //   })
  //   setContacts([...filterContacts])
  // }
  return (
    <>
      {openSnack.open && <DirectionSnackbar message={openSnack.message} color={openSnack.color} />}

      <Button
        size="small"
        sx={{
          color: 'white',
          '&:hover': { color: 'black', backgroundColor: 'white' },
        }}
        onClick={handleClickOpen}
      >
        {t('finance.common.edit')}
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="xs"
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          <Typography
            sx={{ backgroundColor: theme.palette.appBg }}
            align="center"
            variant="h5"
            p={1}
            borderRadius="5px"
            gutterBottom
            component="div"
            color={'black'}
          >
            {t('finance.mesComptes.editAccount')}
          </Typography>
        </DialogTitle>
        <form onSubmit={handleSubmit(addAccount)}>
          <DialogContent style={{ paddingTop: '5px' }}>
            <Grid container spacing={2}>
              <Grid item xs={12} align="center">
                <ComboBox
                  handleAutoComplete={(e, j) => {
                    setSelectedTempBank(j)
                    setValue('bankData', j)
                  }}
                  label="Etablissement Financier"
                  data={tmpBank}
                  name="bankData"
                  required={true}
                  selectedValue={selectedtempBank}
                />
              </Grid>
              {/* <Grid item xs={12} align="center">
                <ComboBox
                  handleAutoComplete={(e, j) => {
                    setselectedContacts(j)
                    setValue('Titulaire', j)
                  }}
                  label="Titulaire"
                  data={contacts}
                  required={true}
                  name="Titulaire"
                  selectedValue={selectedcontacts}
                />
              </Grid> */}
              <Grid item xs={12} align="center">
                <ComboBox
                  handleAutoComplete={(e, j) => {
                    setSelectedTmpAccType(j)
                    setValue('newAccType', j)
                  }}
                  data={tmpAccType}
                  required={true}
                  name="newAccType"
                  label="Type De Compte"
                  selectedValue={selectedtmpAccType}
                />
              </Grid>
              <Grid item xs={12} align="center">
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    type: 'text',
                    required: true,
                    size: 'small',
                  }}
                  rules={{ required: true }}
                  name="IBAN"
                  label="IBAN"
                />
              </Grid>
              <Grid item xs={12} align="center">
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    type: 'text',
                    required: true,
                    size: 'small',
                  }}
                  rules={{ required: true }}
                  name="Devise"
                  label="Devise"
                />
              </Grid>
              <Grid item xs={12} align="center">
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    type: 'text',
                    required: true,
                    size: 'small',
                  }}
                  rules={{ required: true }}
                  name="NumeroClient"
                  label="NumeroClient"
                />
              </Grid>
              <Grid item xs={12} align="center">
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    type: 'number',
                    required: true,
                    size: 'small',
                  }}
                  rules={{ required: true }}
                  name="CléRiB"
                  label="CléRiB"
                />
              </Grid>
              <Grid item xs={12} align="center">
                <Input
                  control={control}
                  inputProps={{
                    variant: 'outlined',
                    type: 'date',
                    required: true,
                    size: 'small',
                  }}
                  InputLabelProps={{ shrink: true }}
                  rules={{ required: true }}
                  name="DateOuverture"
                  label="DateOuverture"
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button autoFocus type="submit">
              {t('finance.common.confirm')}
            </Button>
            <Button onClick={handleClose} autoFocus>
              {t('finance.common.cancel')}
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
